
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Package } from 'lucide-react';

interface OrderDetailsProps {
  orderDetails: {
    packageType: 'silver' | 'gold';
    transactionId: string;
    orderId: string;
    amount: number;
    originalAmount: number;
    discount: number;
    couponCode: string | null;
  };
}

const PaymentSuccessDetails = ({ orderDetails }: OrderDetailsProps) => {
  return (
    <Card className="shadow-md mb-8">
      <CardHeader className="bg-gray-50 border-b">
        <CardTitle className="flex items-center gap-2">
          <Package className="h-5 w-5 text-brand-blue" />
          Order Details
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Package Name</p>
              <p className="font-medium">{orderDetails.packageType === 'silver' ? 'Silver Package' : 'Gold Package'}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Transaction ID</p>
              <p className="font-medium break-all">{orderDetails.transactionId}</p>
            </div>
          </div>
          
          <div className="space-y-1">
            <p className="text-sm text-gray-500">Deliverables</p>
            <p className="font-medium">
              {orderDetails.packageType === 'silver' 
                ? 'Career Assessment Test & Personalized Report' 
                : 'Assessment, Report & Expert Consultation'}
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Order ID</p>
              <p className="font-medium break-all">{orderDetails.orderId}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Order Date</p>
              <p className="font-medium">{new Date().toLocaleDateString()}</p>
            </div>
          </div>
          
          <div className="pt-4 border-t">
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Original Amount:</span>
              <span>₹{orderDetails.originalAmount}</span>
            </div>
            
            {orderDetails.discount > 0 && (
              <div className="flex justify-between mb-2 text-green-600">
                <span>Discount {orderDetails.couponCode ? `(${orderDetails.couponCode})` : ''}:</span>
                <span>-₹{orderDetails.discount}</span>
              </div>
            )}
            
            <div className="flex justify-between font-bold text-lg border-t pt-2 mt-2">
              <span>Amount Paid:</span>
              <span>₹{orderDetails.amount}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentSuccessDetails;
